import { saveToStorage } from "@/taskpane/lib";
import React, { useEffect } from "react";
import { useFREStyles } from "./styles";
import { Button, Image, Text } from "@fluentui/react-components";
import { useRoute } from "@/context/router";
import logoTitleWhite from "@/../assets/logo_title_white.png";
import { CursorClick24Regular, DocumentTableSearch24Regular, Eye24Regular } from "@fluentui/react-icons";

export const FRE = () => {
  const styles = useFREStyles();
  const { setCurrentRoute } = useRoute();

  useEffect(() => {
    const setFREShown = async () => {
      await saveToStorage("showedFRE", "true");
    };
    setFREShown();
  }, []);

  const onContinue = () => {
    setCurrentRoute("login");
  };

  return (
    <div className={styles.container}>
      <Image width="70%" src={logoTitleWhite} />
      <Text className={styles.header} weight="regular" align="center" size={500}>
        Welcome to YellowPad, your AI companion for contracts.
      </Text>

      <div className={styles.featuresContainer}>
        <div className={styles.featureContainer}>
          <Eye24Regular />
          <Text>Identify and summarize key clauses</Text>
        </div>
        <div className={styles.featureContainer}>
          <DocumentTableSearch24Regular />
          <Text>Get automated analysis of risks</Text>
        </div>
        <div className={styles.featureContainer}>
          <CursorClick24Regular />
          <Text>Click to accept revisions aligned with your playbook</Text>
        </div>
      </div>

      <Button iconPosition="after" appearance="primary" className={styles.button} onClick={onContinue}>
        Log in to Continue
      </Button>
    </div>
  );
};
